// `supabase.functions.invoke` only throws on network/HTTP failure and its
// `error.message` is a generic "non-2xx status code" — the actual reason the
// edge function returned lives in the response body. Read it so mutation
// onError toasts can show something the operator can act on.
export async function edgeFunctionErrorMessage(error: unknown, fallback: string): Promise<string> {
  const e = error as { message?: string; context?: Response } | null;
  const body = e?.context ? await e.context.json().catch(() => null) : null;
  return body?.detail || body?.error || e?.message || fallback;
}
